import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface RibbonDriver extends BaseUniDriver {}

export const ribbonDriverFactory = (base: UniDriver): RibbonDriver => {
  return {
    ...baseUniDriverFactory(base),
  };
};
